import { render, staticRenderFns } from "./ActiveChats.vue?vue&type=template&id=ddfaeefc&scoped=true&"
import script from "./ActiveChats.vue?vue&type=script&lang=js&"
export * from "./ActiveChats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfaeefc",
  null
  
)

export default component.exports